import React from "react";
import { Box, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { SubscriptionStatusEnum } from "@rentablo/api/apiv1";

const BaseStatusItem = styled(Box)`
  padding: ${({ theme }) => theme.spacing(1, 2)};
  border-radius: 4px;
  display: flex;
  align-items: center;
`;

const Incomplete = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.warning};
  color: ${({ theme }) => theme.palette.text.warning};
`;

const InProgress = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.warning};
  color: ${({ theme }) => theme.palette.text.warning};
`;

const InternalProcessing = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.upgrade};
  color: ${({ theme }) => theme.palette.text.upgrade};
`;

const Processed = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.success};
  color: ${({ theme }) => theme.palette.text.positive};
`;

const ProcessingAtBank = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.success};
  color: ${({ theme }) => theme.palette.text.positive};
`;

const ContractTerminated = styled(BaseStatusItem)`
  background: ${({ theme }) => theme.palette.background.neutral};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export interface CashbackStatusProps {
  status: SubscriptionStatusEnum | "processing_at_bank_reduced";
  isExternal: boolean;
}

export const CashbackStatus = (props: CashbackStatusProps) => {
  const { status, isExternal } = props;
  const { t } = useTranslation();
  const finalStatus =
    isExternal && status === "in_progress"
      ? "processing_at_bank_reduced"
      : status;

  const label = (
    <Typography variant="body3">
      {t(`domains.cashback.dashboard.status.${finalStatus}`)}
    </Typography>
  );

  switch (finalStatus) {
    case "processed":
      return <Processed>{label}</Processed>;
    case "processing_at_bank":
    case "processing_at_bank_reduced":
      return <ProcessingAtBank>{label}</ProcessingAtBank>;
    case "internal_processing":
      return <InternalProcessing>{label}</InternalProcessing>;
    case "contract_terminated":
      return <ContractTerminated>{label}</ContractTerminated>;
    case "in_progress":
      return <InProgress>{label}</InProgress>;
    case "incomplete":
    default:
      return <Incomplete>{label}</Incomplete>;
  }
};
